<template>
  <GridContainer class="samsung-teasers">
    <GridRow>
      <GridColumn
        v-for="(teaser, index) in teaserItems"
        :key="teaser.title"
        :sm="6"
      >
        <ImageTeaser
          :heading="{
            text: teaser.title,
            tag: 'h2',
          }"
          tile-size="m"
          animate-tile
          lazy
          :animation-delay="index + 1"
          :background="teaser.background"
          class="samsung-teasers__item"
        >
          <template #button>
            <LinkButton
              :to="teaser.button.url"
              primary
              tag="nuxt-link"
            >
              {{ teaser.button.label }}
            </LinkButton>
          </template>
        </ImageTeaser>
      </GridColumn>
    </GridRow>
  </GridContainer>
</template>

<script>
import {
  ImageTeaser,
  GridContainer,
  GridRow,
  GridColumn,
  LinkButton,
} from '@i22/td-longtail-vue-components';

export default {
  name: 'SamsungTeasers',
  components: {
    GridContainer,
    GridRow,
    GridColumn,
    LinkButton,
    ImageTeaser,
  },
  props: {
    teaserItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
$image-teaser: '.image-teaser';

.samsung-teasers {
  &__item {
    @include mq($mq-md) {
      margin-bottom: 6rem;
    }
  }

  :deep(#{$image-teaser}__container) {
    padding: 4rem 0;
    max-width: 50%;

    @include mq($mq-sm) {
      padding: 0;
      max-width: none;
    }
  }
}
</style>
